require('@fontsource/inter/latin-400.css');
require('@fontsource/inter/latin-500.css');
require('@fontsource/inter/latin-600.css');
require('@fontsource/inter/latin-700.css');
require('@fontsource/inter/latin-800.css');
require('@fontsource/inter/latin-900.css');
require('@fontsource/inter/latin-ext-400.css');
require('@fontsource/inter/latin-ext-500.css');
require('@fontsource/inter/latin-ext-600.css');
require('@fontsource/inter/latin-ext-700.css');
require('@fontsource/inter/latin-ext-800.css');
require('@fontsource/inter/latin-ext-900.css');
